export default __webpack_public_path__ + "media/images/47-15d4b7a24789fcd88c8f3e75090a4823.jpg";